export default function mapAllResources(items, resources) {
  return items ? items.map(function (_ref) {
    var schema = _ref.schema,
        id = _ref.id;
    return resources[schema.endsWith('s') ? schema + 'es' : schema + 's'][id];
  }) : null;
}